if (!customElements.get('maison-purchase-bar')) {
  customElements.define('maison-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(this.dataset.productSection);
      if (!this.root) return;
      this.button = this.querySelector('button');
      this.price = this.querySelector('[data-maison-price]');
      this.options = this.querySelector('[data-maison-options]');
      this.nativeVisible = false;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.sync = this.sync.bind(this);
      this.onClick = () => {
        const nativeButton = this.root.querySelector('product-form button[name="add"]');
        if (nativeButton && !nativeButton.disabled && nativeButton.getAttribute('aria-disabled') !== 'true') {
          nativeButton.click();
        }
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.root, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'value']});
      this.notification = document.querySelector('cart-notification');
      if (this.notification) {
        this.cartObserver = new MutationObserver(this.sync);
        this.cartObserver.observe(this.notification, {subtree: true, attributes: true, attributeFilter: ['class', 'open']});
      }
      this.intersection = new IntersectionObserver(entries => {
        this.nativeVisible = entries[0].intersectionRatio >= 0.98;
        this.sync();
      }, {threshold: [0, 0.98]});
      const nativeButton = this.root.querySelector('product-form button[name="add"]');
      if (nativeButton) this.intersection.observe(nativeButton);
      // Fallback for in-app browsers/webviews: measure the native button on scroll as well.
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          const btn = this.root.querySelector('product-form button[name="add"]');
          if (!btn) return;
          const r = btn.getBoundingClientRect();
          const visible = r.height > 0 && r.top >= 0 && r.bottom <= window.innerHeight;
          if (visible !== this.nativeVisible) {
            this.nativeVisible = visible;
            this.sync();
          }
        });
      };
      window.addEventListener('scroll', this.onScroll, {passive: true});
      window.addEventListener('resize', this.onScroll, {passive: true});
      this.onScroll();
      this.mobile.addEventListener('change', this.sync);
      this.sync();
    }
    sync() {
      const nativeButton = this.root.querySelector('product-form button[name="add"]');
      const notificationOpen = document.querySelector('cart-notification .cart-notification.active, #cart-notification.active, cart-drawer.active');
      this.hidden = !this.mobile.matches || this.nativeVisible || Boolean(notificationOpen);
      if (!nativeButton) {
        this.button.disabled = true;
        return;
      }
      this.button.disabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
      this.button.textContent = nativeButton.querySelector('span')?.textContent.trim() || 'Add to cart';
      const price = this.root.querySelector('.price:not(.price--on-sale) .price-item--regular, .price--on-sale .price-item--sale');
      this.price.textContent = price?.textContent.trim() || '';
      const picker = Array.from(this.root.querySelectorAll('variant-selects')).find(node => node.style.display !== 'none');
      this.options.textContent = picker ? Array.from(picker.querySelectorAll('input:checked, select')).map(input => (input.tagName === 'SELECT' ? input.selectedOptions[0]?.dataset.maisonLabel || input.value : input.dataset.maisonLabel || input.value)).join(' / ') : '';
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.cartObserver?.disconnect();
      this.intersection?.disconnect();
      this.mobile?.removeEventListener('change', this.sync);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
